<app-dialog
  [visible]="visible() && !!row()"
  [width]="'920px'"
  [header]="'EXTERNAL_SCENES.DIALOG_TITLE'"
  [showFooter]="false"
  [dismissableMask]="true"
  appendTo="body"
  [overlayZIndex]="99999"
  (visibleChange)="onVisibleChange($event)">
  @if (row(); as scene) {
    <div class="quick-view">
      <div class="quick-view__preview">
        @if (showPreview()) {
          <img
            class="quick-view__image"
            [src]="scene.previewUrl"
            [alt]="scene.name"
            (error)="onPreviewError()" />
          @if (scene.previewFormat) {
            <span class="quick-view__chip">
              {{ 'EXTERNAL_SCENES.QUICK_VIEW_CHIP' | translate: { format: scene.previewFormat } }}
            </span>
          }
        } @else {
          <span class="quick-view__placeholder">{{ 'EXTERNAL_SCENES.QUICK_VIEW_NO_PREVIEW' | translate }}</span>
        }
      </div>

      <div class="quick-view__details">
        <h3 class="quick-view__name">{{ scene.name }}</h3>

        <dl class="quick-view__meta">
          <div class="quick-view__meta-row">
            <dt>{{ 'EXTERNAL_SCENES.COLUMN_SOURCE' | translate }}</dt>
            <dd>
              <span class="quick-view__provider {{ providerClass() }}">
                {{ scene.providerLabelKey | translate }}
              </span>
            </dd>
          </div>
          <div class="quick-view__meta-row">
            <dt>{{ 'EXTERNAL_SCENES.COLUMN_DATE' | translate }}</dt>
            <dd>{{ scene.acquiredAt | date: 'dd.MM.yyyy HH:mm' }}</dd>
          </div>
          @if (scene.cloudCoverLabel) {
            <div class="quick-view__meta-row">
              <dt>{{ 'EXTERNAL_SCENES.COLUMN_CLOUD_COVER' | translate }}</dt>
              <dd>{{ scene.cloudCoverLabel }}</dd>
            </div>
          }
          @if (scene.sizeLabel) {
            <div class="quick-view__meta-row">
              <dt>{{ 'EXTERNAL_SCENES.COLUMN_SIZE' | translate }}</dt>
              <dd>{{ scene.sizeLabel }}</dd>
            </div>
          }
          @if (scene.etaMinutes !== null) {
            <div class="quick-view__meta-row">
              <dt>{{ 'EXTERNAL_SCENES.COLUMN_ETA' | translate }}</dt>
              <dd>
                {{ 'EXTERNAL_SCENES.ETA_MINUTES' | translate: { minutes: scene.etaMinutes } }}
                <span class="quick-view__hint">{{ 'EXTERNAL_SCENES.ETA_SPEED_NOTE' | translate: { speed: downloadSpeed } }}</span>
              </dd>
            </div>
          }
          @if (coordinatesLabel()) {
            <div class="quick-view__meta-row">
              <dt>{{ 'EXTERNAL_SCENES.COORDINATES' | translate }}</dt>
              <dd>{{ coordinatesLabel() }}</dd>
            </div>
          }
          <div class="quick-view__meta-row">
            <dt>{{ 'EXTERNAL_SCENES.COLUMN_STATUS' | translate }}</dt>
            <dd>{{ scene.statusKey | translate }}</dd>
          </div>
        </dl>

        @if (scene.errorKey) {
          <p class="quick-view__error" role="alert">{{ scene.errorKey | translate }}</p>
        }

        <div class="quick-view__actions">
          <app-external-scene-action [row]="scene" (loadClick)="loadClick.emit($event)"></app-external-scene-action>
        </div>
      </div>
    </div>
  }
</app-dialog>
